// src/pages/Departments.js
import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function Departments() {
  const [depts, setDepts] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ code:'', name_ku:'', name_ar:'' });
  const [editing, setEditing] = useState(null);

  const load = () => api.get('/departments').then(r => setDepts(r.data));
  useEffect(load, []);

  const open = (d = null) => {
    setEditing(d);
    setForm(d ? { code:d.code, name_ku:d.name_ku, name_ar:d.name_ar||'' } : { code:'', name_ku:'', name_ar:'' });
    setModal(true);
  };

  const save = async () => {
    try {
      if (editing) await api.put(`/departments/${editing.id}`, form);
      else await api.post('/departments', form);
      toast.success('تۆمارکرا');
      setModal(false);
      load();
    } catch (err) { toast.error(err.response?.data?.error || 'هەڵە'); }
  };

  return (
    <div style={styles.page}>
      <div style={styles.topbar}>
        <h1 style={styles.title}>🏢 بەشەکان</h1>
        <button onClick={() => open()} style={styles.newBtn}>➕ بەشی نوێ</button>
      </div>
      <div style={styles.grid}>
        {depts.map(d => (
          <div key={d.id} style={styles.card}>
            <div style={styles.code}>{d.code}</div>
            <div style={styles.name}>{d.name_ku}</div>
            {d.name_ar && <div style={styles.nameAr}>{d.name_ar}</div>}
            <button onClick={() => open(d)} style={styles.editBtn}>✏️ دەستکاری</button>
          </div>
        ))}
      </div>

      {modal && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <h2 style={styles.modalTitle}>{editing ? 'دەستکاری بەش' : 'بەشی نوێ'}</h2>
            <div style={styles.fields}>
              <div style={styles.field}><label style={styles.label}>کۆدی بەش *</label>
                <input style={styles.inp} value={form.code} onChange={e=>setForm({...form,code:e.target.value.toUpperCase()})} placeholder="DEPT01" /></div>
              <div style={styles.field}><label style={styles.label}>ناوی کوردی *</label>
                <input style={styles.inp} value={form.name_ku} onChange={e=>setForm({...form,name_ku:e.target.value})} /></div>
              <div style={styles.field}><label style={styles.label}>ناوی عەرەبی</label>
                <input style={styles.inp} value={form.name_ar} onChange={e=>setForm({...form,name_ar:e.target.value})} /></div>
            </div>
            <div style={styles.btnRow}>
              <button onClick={save} style={styles.saveBtn}>💾 تۆمار</button>
              <button onClick={()=>setModal(false)} style={styles.cancelBtn}>❌ داخستن</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  page:{padding:20}, topbar:{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16},
  title:{fontSize:20,fontWeight:'bold',color:'#1a5276',margin:0},
  newBtn:{background:'linear-gradient(135deg,#1a5276,#2980b9)',color:'#fff',border:'none',borderRadius:8,padding:'10px 18px',fontSize:13,fontWeight:'bold',cursor:'pointer'},
  grid:{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))',gap:16},
  card:{background:'#fff',borderRadius:10,padding:16,boxShadow:'0 2px 8px rgba(0,0,0,0.08)',display:'flex',flexDirection:'column',gap:4},
  code:{background:'#1a5276',color:'#fff',borderRadius:6,padding:'2px 10px',fontSize:11,fontWeight:'bold',display:'inline-block',alignSelf:'flex-start'},
  name:{fontSize:14,fontWeight:'bold',color:'#222',marginTop:4},
  nameAr:{fontSize:12,color:'#666'},
  editBtn:{background:'#eaf2fb',color:'#1a5276',border:'1px solid #1a5276',borderRadius:6,padding:'5px 12px',cursor:'pointer',fontSize:12,marginTop:8},
  overlay:{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000},
  modal:{background:'#fff',borderRadius:12,padding:28,width:380,direction:'rtl'},
  modalTitle:{fontSize:16,fontWeight:'bold',color:'#1a5276',marginBottom:16},
  fields:{display:'flex',flexDirection:'column',gap:12,marginBottom:16},
  field:{display:'flex',flexDirection:'column',gap:4}, label:{fontSize:12,fontWeight:'bold',color:'#555'},
  inp:{padding:'8px 10px',border:'1.5px solid #ddd',borderRadius:6,fontSize:13,fontFamily:'inherit'},
  btnRow:{display:'flex',gap:8,justifyContent:'flex-end'},
  saveBtn:{background:'#1a5276',color:'#fff',border:'none',borderRadius:6,padding:'9px 18px',cursor:'pointer',fontSize:13},
  cancelBtn:{background:'#f0f0f0',border:'none',borderRadius:6,padding:'9px 18px',cursor:'pointer',fontSize:13},
};
